import { createContext, useContext } from "react";

interface DetailBreadcrumbContextType {
  entityLabel: string | null;
  setEntityLabel: (label: string | null) => void;
}

const DetailBreadcrumbContext = createContext<DetailBreadcrumbContextType>({
  entityLabel: null,
  setEntityLabel: () => {},
});

export const useDetailBreadcrumb = () => useContext(DetailBreadcrumbContext);

export default DetailBreadcrumbContext;
